<template>
  <v-container fluid>
    <PageHeading
      :text="$t('pages-name.children.categories')"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-category-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          {{ $t('page-categories.btn-create') }}
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridEventCategories ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridEventCategories from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageEventsCategory',
  components: {
    PageHeading,
    GridEventCategories
  },
  metaInfo () {
    return {
      title: this.$t('pages-name.parent.categories')
    }
  },
  mixins: [gridPageInterface]
}
</script>
